import React, { useState, useEffect } from 'react';
import serverApi from '../../api/server';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import MerchantWallets from './MerchantWallets'
import './Merchant.css';
import DeleteIcon from '@mui/icons-material/Delete';
import AddMerchant from './AddMerchant';
import EditMerchant from './EditMerchant';
import DeleteMerchantWarning from './DeleteMerchantWarning'
interface Merchant {
    Name: string;
    Description: string;
    Tags: any[];
}
const Transition = React.forwardRef(function Transition(props:any, ref:any) {
    return <Slide direction="left" ref={ref} {...props} />;
  });
function MerchantTable({isAdmin}: any) {
    const [merchants, setMerchants] = useState<Merchant[]>([]);
    const [searchValue, setSearchValue] = useState('');
    const [openMerchantWallets, setOpenMerchantWallets] = useState(false)
    const [selectedMerchant, setSelectedMerchant] = useState<Merchant>()
    const [openAddMerchant, setOpenAddMerchant] = useState(false)
    const [openEditMerchant, setOpenEditMerchant] = useState(false)
    const [update, setUpdate] = useState(0);
    const [openDelete, setOpenDelete] = useState(false);
    const getMerchantListData = async() : Promise<any[]> => {
        try {
            let resultJSONData;
            const result = await serverApi.get('/getMerchants'
                // {headers: {Authorization: signature}}
            )
            console.log(result)
            resultJSONData = result.data
            console.log(resultJSONData)
            setMerchants(resultJSONData)
            return resultJSONData
        }
        catch (err) {
            alert(err)
            return []
        }
    }
    useEffect(() => {
        getMerchantListData()
    },[update])
    const handleSearchMerchantValueOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let inputValue = (e.target.value) //.trim()
        setSearchValue(inputValue)
    }
    const handleClickClearSearchInput = () => {
        setSearchValue('')
    }
    const handleAddMerchantModal = () => {
        console.log("add new merchant")
        setOpenAddMerchant(true)
    }
    const openMerchantDialog = (merchant: Merchant) => {
        console.log(merchant);
        setSelectedMerchant(merchant)
        setOpenMerchantWallets(true)
    }
    const handleCloseMerchantDialog = () => {
        setOpenMerchantWallets(false)
    }
    const handleCloseAddMerchantDialog = () => {
        setOpenAddMerchant(false)
    }
    const handleCloseEditMerchantDialog = () => {
        setOpenEditMerchant(false)
    }
    const handleOpenEditMerchantDialog = (merchant: Merchant) => {
        setSelectedMerchant(merchant)
        setOpenEditMerchant(true)
    }
    const handleOpenDeleteConfirmation = (merchant: Merchant) => {
        setSelectedMerchant(merchant)
        setOpenDelete(true)
    }
    const handleDeleteMerchant = async() => {
        try{
            let requestBody = {
                name: selectedMerchant?.Name,
            }
            const result = await serverApi.post('/deleteMerchant', requestBody
                // {headers: {Authorization: signature}}
            )
            console.log(result)
            if(result.status === 200){
                let count = update + 1
                setUpdate(count)
                setOpenDelete(false)
            }
            
        }
        catch(err){
            console.log(err)
            alert(err)
        }
    }
    return (
        <div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                <Paper
                    component="form"
                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 350, marginBottom: 1 }}
                >
                    <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        value={searchValue}
                        onChange={handleSearchMerchantValueOnChange}
                        placeholder="Search Merchant"
                        inputProps={{ 'aria-label': 'search merchant or tag' }}
                        disabled={merchants.length === 0}
                        endAdornment={searchValue? 
                            <InputAdornment position="end">
                                <IconButton
                                    size='small'
                                    onClick={handleClickClearSearchInput}
                                    style={{borderRadius: 0}}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </InputAdornment> : <SearchIcon />}
                    />
                    
                </Paper>
                <Button sx={{height: '90%'}} disabled={!isAdmin} variant="outlined" size="small" endIcon={<AddIcon />} onClick={() => handleAddMerchantModal()}>
                    Add Merchant
                </Button>
            </div>
            <div className='wrapper'>
                {merchants.filter((i: any) => searchValue? (i.Name).toUpperCase().includes(searchValue.toUpperCase()) || i.Tags.map((t:string) => t.toUpperCase()).includes(searchValue.toUpperCase()) : i).map((merchant, index) => 
                    <Card sx={{ width: 275 }} raised key={index}>
                        <CardActionArea onClick={() => openMerchantDialog(merchant)}>
                        <CardContent>
                            <Typography variant="h5" component="div">
                                {merchant.Name}
                            </Typography>
                            <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                {merchant.Description}
                            </Typography>
                            <Typography variant="body2">
                                Tags: {merchant.Tags.length> 0 ? merchant.Tags.join(', '): 'N/A'}
                            <br />
                            </Typography>
                        </CardContent>
                        </CardActionArea>
                        <CardActions>
                            <Button size="small" color="primary" disabled={!isAdmin} onClick={() => handleOpenEditMerchantDialog(merchant)}>
                                Edit
                            </Button>
                            <Button color="error" endIcon={<DeleteIcon />} disabled={!isAdmin} onClick={() => handleOpenDeleteConfirmation(merchant)}>
                                Delete
                            </Button>
                        </CardActions>
                    </Card>
                    )}
            </div>
            <AddMerchant 
                openAddMerchant={openAddMerchant} 
                handleCloseAddMerchant={handleCloseAddMerchantDialog} 
                update={update}
                setUpdate={setUpdate}
                // isAdmin={isAdmin}
            />
            <EditMerchant 
                curMerchant={selectedMerchant}
                openEditMerchant={openEditMerchant}
                handleCloseEditMerchant={handleCloseEditMerchantDialog}
                update={update}
                setUpdate={setUpdate}
                selectedMerchant={selectedMerchant}
                // isAdmin={isAdmin}
            />
            <DeleteMerchantWarning open={openDelete} closeDialog={() => setOpenDelete(false)} confirmDialog={handleDeleteMerchant}/>
            <Dialog
                fullScreen
                open={openMerchantWallets}
                onClose={handleCloseMerchantDialog}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative' }} color="transparent">
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCloseMerchantDialog}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            {selectedMerchant?.Name}
                        </Typography>
                        {/* <Button autoFocus color="inherit" onClick={handleCloseMerchantDialog}>
                            save
                        </Button> */}
                    </Toolbar>
                </AppBar>
                <MerchantWallets merchant={selectedMerchant?.Name} isAdmin={isAdmin} />
            </Dialog>
        </div>
    );
}

export default MerchantTable;